import React from 'react';

import { useIntl } from 'react-intl-next';

import { Text } from '@atlaskit/primitives';

import messages from './messages';
import { Condition } from './styled';
import { type ConditionListProps } from './types';

export const ConditionList = ({ data, matchType, noConditionMessage }: ConditionListProps) => {
	const { formatMessage } = useIntl();

	if (matchType === 0 && noConditionMessage) {
		return <Condition>{noConditionMessage}</Condition>;
	}

	return (
		<>
			{data.map((condition, i) => {
				const { fieldFreeForm, field, not, operation, expectedValue } = condition;

				const value = expectedValue ?? (operation !== 10 ? 'null' : false);

				return (
					<Condition isCapitalized={i === 0} key={i}>
						{i > 0 && (
							<>
								{matchType === 1 &&
									formatMessage(messages['or'], {
										strong: (str: React.ReactNode) => <Text as="strong">{str}</Text>,
									} as any)}
								{matchType === 2 &&
									formatMessage(messages['and'], {
										strong: (str: React.ReactNode) => <Text as="strong">{str}</Text>,
									})}
							</>
						)}
						{formatMessage(messages.operationVerbalForm, {
							field,
							not,
							fieldFreeForm,
							operation,
							value,
							strong: (str: React.ReactNode) => <Text as="strong">{str}</Text>,
						})}
					</Condition>
				);
			})}
		</>
	);
};
